<template>
  <section id="projects-block" class="projects-section">
    <v-container>
      <div class="chapter-eyebrow">
        <span class="ch-label">{{ $t('homepage.projects.title') }}</span>
        <span class="ch-meta">{{ $t('homepage.projects.meta') }}</span>
      </div>

      <div class="content-grid">
        <div class="visual-col">
          <figure class="project-photo">
            <transition mode="out-in" :css="false" @enter="onEnterFade" @leave="onLeaveFade">
              <OptimizedImage
                :webp="activeProject.background"
                :avif="activeProject.backgroundAvif"
                :key="activeProject.id"
                :alt="activeProject.title"
                :img-class="['project-photo-img', { 'photo-ksaf': activeProject.ksafWatermark }]"
                loading="eager"
              />
            </transition>
            <figcaption>
              <span class="cap-num">0{{ activeProject.id }}</span>
              <span class="cap-text">{{ activeProject.title }}</span>
            </figcaption>
          </figure>
        </div>

        <div class="text-col">
          <transition mode="out-in" :css="false" @enter="onEnterLeft" @leave="onLeaveLeft">
            <h2 :key="'h-' + activeProject.id">{{ activeProject.title }}</h2>
          </transition>

          <transition mode="out-in" :css="false" @enter="onEnter" @leave="onLeave">
            <div :key="'d-' + activeProject.id" class="desc-wrap">
              <span class="desc-summary">{{ $t('homepage.projects.summary') }}</span>
              <p class="desc">{{ activeProject.description }}</p>
            </div>
          </transition>

          <div class="project-switcher">
            <button
              v-for="project in projects"
              :key="project.id"
              class="proj-btn"
              :class="{ active: project.id === value }"
              @click="value = project.id"
            >
              <span class="proj-num">0{{ project.id }}</span>
              <span class="proj-name">{{ project.title }}</span>
              <span class="proj-arrow">→</span>
            </button>
          </div>
        </div>
      </div>

      <transition :css="false" @enter="onEnterFadeThank" @leave="onLeaveFadeThank">
        <div v-if="value === 2" class="thanks-block">
          <p class="thanks-text">{{ $t('homepage.thanks.desc') }}</p>
          <img src="@/assets/img/components/partners/logo/mnisw_kolor.webp" class="thanks-logo" alt="Ministerstwo Nauki i Szkolnictwa Wyższego" loading="lazy" decoding="async">
        </div>
      </transition>
    </v-container>
  </section>
</template>

<script>
import anime from '../../../node_modules/animejs/lib/anime.es.js'
import OptimizedImage from '@/components/common/OptimizedImage.vue'

export default {
  name: 'ProjectsComponent',
  components: { OptimizedImage },
  data() {
    return {
      value: 1
    }
  },
  computed: {
    projects() {
      return [
        {
          id: 1,
          background: require('../../assets/img/components/projects/delta.webp'),
          backgroundAvif: require('../../assets/img/components/projects/delta.avif'),
          title: this.$t('homepage.projects.delta.title'),
          description: this.$t('homepage.projects.delta.desktop')
        },
        {
          id: 2,
          background: require('../../assets/img/components/projects/barka.webp'),
          backgroundAvif: require('../../assets/img/components/projects/barka.avif'),
          title: this.$t('homepage.projects.barka.title'),
          description: this.$t('homepage.projects.barka.desktop')
        },
        {
          id: 3,
          background: require('../../assets/img/components/projects/celka.webp'),
          backgroundAvif: require('../../assets/img/components/projects/celka.avif'),
          title: this.$t('homepage.projects.celka.title'),
          description: this.$t('homepage.projects.celka.desktop'),
          ksafWatermark: true
        },
        {
          id: 4,
          background: require('../../assets/img/components/projects/ROBUR.webp'),
          backgroundAvif: require('../../assets/img/components/projects/ROBUR.avif'),
          title: this.$t('homepage.projects.robur.title'),
          description: this.$t('homepage.projects.robur.desktop')
        },
        {
          id: 5,
          background: require('../../assets/img/components/projects/baska_2.webp'),
          backgroundAvif: require('../../assets/img/components/projects/baska_2.avif'),
          title: this.$t('homepage.projects.baska.title'),
          description: this.$t('homepage.projects.baska.desktop'),
          ksafWatermark: true
        }
      ]
    },
    activeProject() {
      return this.projects.find(p => p.id === this.value) || this.projects[0]
    }
  },
  methods: {
    onEnter(el, done) {
      anime({
        targets: el,
        translateY: [40, 0],
        opacity: [0, 1],
        easing: 'easeOutQuart',
        duration: 600,
        complete: done
      })
    },
    onLeave(el, done) {
      anime({
        targets: el,
        translateY: [0, -40],
        opacity: [1, 0],
        easing: 'easeInQuart',
        duration: 400,
        complete: done
      })
    },
    onEnterLeft(el, done) {
      anime({
        targets: el,
        translateX: [60, 0],
        opacity: [0, 1],
        easing: 'easeOutQuart',
        duration: 700,
        complete: done
      })
    },
    onLeaveLeft(el, done) {
      anime({
        targets: el,
        translateX: [0, -40],
        opacity: [1, 0],
        easing: 'easeInQuart',
        duration: 400,
        complete: done
      })
    },
    onEnterFade(el, done) {
      anime({
        targets: el,
        opacity: [0, 1],
        easing: 'easeInOutSine',
        duration: 800,
        complete: done
      })
    },
    onLeaveFade(el, done) {
      anime({
        targets: el,
        opacity: [1, 0],
        easing: 'easeInOutSine',
        duration: 600,
        complete: done
      })
    },
    onEnterFadeThank(el, done) {
      anime({
        targets: el,
        opacity: [0, 1],
        translateY: [20, 0],
        easing: 'easeOutQuart',
        duration: 700,
        delay: 300,
        complete: done
      })
    },
    onLeaveFadeThank(el, done) {
      anime({
        targets: el,
        opacity: [1, 0],
        easing: 'easeInOutSine',
        duration: 500,
        complete: done
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  .projects-section
    background: #ffffff
    color: #0a0828
    padding: clamp(70px, 10vw, 110px) 0
    position: relative

  .chapter-eyebrow
    display: flex
    align-items: baseline
    gap: 32px
    margin-bottom: 60px

    .ch-label
      font-family: Inter, sans-serif
      font-weight: 700
      font-size: 0.78em
      letter-spacing: 0.22em
      text-transform: uppercase
      color: #0a0828

    .ch-meta
      font-family: Inter, sans-serif
      font-weight: 500
      font-size: 0.78em
      letter-spacing: 0.16em
      text-transform: uppercase
      color: #5b637e
      margin-left: auto

  .content-grid
    display: grid
    grid-template-columns: 1.05fr 1fr
    gap: 70px
    align-items: start

  .visual-col
    position: relative

  .project-photo
    margin: 0
    padding: 0
    position: relative
    overflow: hidden

    ::v-deep .optimized-image
      width: 100%

    img
      width: 100%
      max-width: 100%
      aspect-ratio: 4 / 3
      max-height: 520px
      object-fit: cover
      object-position: center
      display: block

      &.photo-ksaf
        aspect-ratio: unset
        max-height: min(70vw, 420px)
        width: 100%
        height: auto
        object-fit: contain

    figcaption
      display: flex
      align-items: baseline
      gap: 18px
      padding: 18px 0 0
      font-family: Inter, sans-serif

      .cap-num
        font-weight: 700
        font-size: 0.74em
        letter-spacing: 0.22em
        text-transform: uppercase
        color: #0a0828
        flex-shrink: 0

      .cap-text
        font-weight: 500
        font-size: 0.82em
        letter-spacing: 0.04em
        color: #5b637e

  .text-col
    display: flex
    flex-direction: column

    h2
      font-family: Raleway, sans-serif
      font-weight: 900
      font-size: clamp(2rem, 9vw, 4.6em)
      line-height: 0.9
      letter-spacing: -0.045em
      text-transform: uppercase
      color: #0a0828
      margin: 0 0 clamp(18px, 3vw, 28px)

    .desc-wrap
      max-width: 560px
      margin-bottom: 36px
      min-height: 130px

    .desc-summary
      display: block
      font-family: Inter, sans-serif
      font-weight: 700
      font-size: 0.74em
      letter-spacing: 0.22em
      text-transform: uppercase
      color: #0a0828
      margin-bottom: 12px

    .desc
      font-family: Inter, sans-serif
      font-size: 0.98em
      line-height: 1.7em
      color: #2a2750
      margin: 0

  .project-switcher
    display: flex
    flex-direction: column
    margin-top: auto

    .proj-btn
      display: flex
      align-items: baseline
      gap: 20px
      padding: 16px 0
      border: none
      background: transparent
      border-bottom: 1px solid rgba(10, 8, 40, 0.12)
      cursor: pointer
      text-align: left
      width: 100%

      &:first-child
        border-top: 1px solid rgba(10, 8, 40, 0.12)

      .proj-num
        font-family: Inter, sans-serif
        font-weight: 700
        font-size: 0.74em
        letter-spacing: 0.22em
        text-transform: uppercase
        color: rgba(10, 8, 40, 0.4)
        flex-shrink: 0
        transition: color 0.3s

      .proj-name
        font-family: Raleway, sans-serif
        font-weight: 700
        font-size: clamp(1rem, 3.5vw, 1.25em)
        line-height: 1.1
        letter-spacing: -0.02em
        color: rgba(10, 8, 40, 0.4)
        flex: 1
        transition: color 0.3s

      .proj-arrow
        font-family: Raleway, sans-serif
        font-weight: 700
        font-size: 1.05em
        color: transparent
        flex-shrink: 0
        transition: color 0.3s, transform 0.3s

      &:hover
        .proj-num, .proj-name
          color: rgba(10, 8, 40, 0.7)

      &.active
        .proj-num
          color: #0a0828
        .proj-name
          color: #0a0828
        .proj-arrow
          color: #0a0828
          transform: translateX(4px)

  .thanks-block
    display: flex
    align-items: center
    justify-content: space-between
    gap: 40px
    margin-top: 110px
    padding: 32px 36px
    background: #faf7f1
    border-left: 4px solid #0a0828

    .thanks-text
      font-family: Inter, sans-serif
      font-size: 0.95em
      line-height: 1.65em
      color: #2a2750
      margin: 0
      flex: 1
      min-width: 0

    .thanks-logo
      height: 60px
      width: auto
      flex-shrink: 0

  @media only screen and (max-width: 1180px)
    .content-grid
      gap: 50px

  @media only screen and (max-width: 900px)
    .chapter-eyebrow
      gap: 14px
      margin-bottom: 36px
      flex-wrap: wrap

      .ch-label, .ch-meta
        font-size: 0.7em
        letter-spacing: 0.18em

      .ch-meta
        margin-left: 0
        width: 100%

    .content-grid
      grid-template-columns: 1fr
      gap: 40px

    .project-photo img
      aspect-ratio: 16 / 10
      max-height: min(55vw, 380px)

    .project-photo img.photo-ksaf
      max-height: min(75vw, 360px)
      object-fit: contain

    .text-col
      .desc-wrap
        min-height: 0
        margin-bottom: 28px

    .project-switcher .proj-btn
      padding: 14px 0

    .thanks-block
      flex-direction: column
      align-items: flex-start
      gap: 16px
      padding: 24px 28px
      margin-top: 60px

      .thanks-logo
        align-self: flex-end
        height: 48px

  @media only screen and (max-width: 600px)
    .project-photo img
      max-height: min(62vw, 280px)

    .project-photo img.photo-ksaf
      max-height: min(78vw, 300px)
</style>
